import React from 'react';

import {
  Labeled,
  required,
  TextInput,
} from 'react-admin';

import {
  Grid,
} from '@mui/material';

import CreateDialog from '../layout/dialog/CreateDialog';

const TransactionTypeCreate = () => (
  <CreateDialog title="transaction type">
    <Grid container spacing={6}>
      <Grid size={12}>
        <Labeled label="Name">
          <TextInput fullWidth validate={required()} source="name" label="" helperText={false} />
        </Labeled>
      </Grid>
    </Grid>
  </CreateDialog>

);

export default TransactionTypeCreate;
